// src/Pages/ShipDeliveryPolicy.js
import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../Pages/Navbar/JobSeekerNavbar";
import Footer from "../../Footer/Footer";
import { Container } from "react-bootstrap";
import "./ShipPolicy.css";

function ShipDeliveryPolicy() {
  const navigate = useNavigate();

  const handleGmailCompose = (e) => {
    e.preventDefault();
    const email = "support@gulfworker.net"; // ✅ support email
    const subject = encodeURIComponent("Support Request: Shipping & Delivery");
    const body = encodeURIComponent(
      "Hi Gulfworker Team,\n\nI have a question regarding the Shipping & Delivery Policy..."
    );

    // ✅ Open Gmail compose in new tab
    const gmailComposeURL = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`;
    window.open(gmailComposeURL, "_blank");

    // ✅ Navigate after 2 seconds
    setTimeout(() => {
      navigate("/jobseeker-shipping-delivery-policy");
    }, 2000);
  };

  return (
    <>
      <Navbar />
      <div className="policy-section py-5 mt-5">
        <Container>
          <h1 className="mb-4 text-center fw-bold">Shipping & Delivery Policy</h1>

          <p>
            At <strong>Gulfworker.net</strong>, we strive to provide timely and
            reliable digital delivery of our services. As our platform primarily
            offers job portal and subscription services, the concept of shipping
            applies to activation and accessibility of purchased plans rather
            than physical products.
          </p>

          <div className="mt-4">
            <h4>1. Service Delivery Timeline</h4>
            <ul>
              <li>
                Once a subscription or premium service is purchased, it will be
                activated <strong>instantly</strong> upon successful payment.
              </li>
              <li>
                In rare cases, activation may take up to 24 hours due to
                technical or payment gateway delays.
              </li>
            </ul>

            <h4>2. Confirmation of Service</h4>
            <ul>
              <li>
                Users will receive a confirmation email with details of their
                subscription plan.
              </li>
              <li>
                Employers can immediately access premium features (e.g.,
                highlighted/featured job postings).
              </li>
            </ul>

            <h4>3. Shipping Charges</h4>
            <p>
              Since services are delivered digitally,{" "}
              <strong>no physical shipping charges</strong> are applicable.
            </p>

            <h4>4. International Access</h4>
            <p>
              Gulfworker.net is accessible globally, subject to local laws and
              internet availability. Employers and candidates from different
              countries may use our services without additional charges.
            </p>

            <h4>5. Delays & Technical Issues</h4>
            <ul>
              <li>
                In case of delays in service activation, users should contact our
                support team at{" "}
                <a href="#" onClick={handleGmailCompose}>
                  support@gulfworker.net
                </a>
                .
              </li>
              <li>
                We will ensure prompt resolution and activate the service as soon
                as possible.
              </li>
            </ul>

            <h4>6. Contact Us</h4>
            <p>
              For questions or concerns regarding service delivery, please
              contact our support team at:{" "}
              <a href="#" onClick={handleGmailCompose}>
                  support@gulfworker.net
              </a>
            </p>
          </div>
        </Container>
      </div>
      <Footer />
    </>
  );
}

export default ShipDeliveryPolicy;
